import * as React from "react";
import { Icon } from "@chakra-ui/react";
const Internal = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#fff", d: "m6.346 14.4-.019-5.818H4V6.255h2.327V4.8c0-2.16 1.337-3.2 3.264-3.2.923 0 1.716.069 1.947.1v2.256h-1.336c-1.048 0-1.25.498-1.25 1.229v1.07H12l-1.164 2.327H8.951V14.4z" }));
const SvgFacebook = (props) => {
  return /* @__PURE__ */ React.createElement(Icon, { as: Internal, ...props });
};
export default SvgFacebook;
